(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["miamur-shelf-bra-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const product = document.querySelector('product-info[data-product-id="8859026194732"]');
    if (!product || !('IntersectionObserver' in window)) return;

    const scope = product.closest('.shopify-section') || product;
    const mobile = window.matchMedia('(max-width: 749px)');
    const className = 'miamur-shelf-buy-in-view';
    let observer;
    let mutationObserver;
    let controls = [];
    const visibleControls = new Set();

    const syncControls = () => {
      const next = [...scope.querySelectorAll('.product-form__buttons, .miamur-sticky-atc')];
      if (next.length === controls.length && next.every((control, index) => control === controls[index])) return;
      observer.disconnect();
      visibleControls.clear();
      controls = next;
      document.documentElement.classList.remove(className);
      controls.forEach((control) => observer.observe(control));
    };

    const syncViewport = () => {
      observer?.disconnect();
      mutationObserver?.disconnect();
      controls = [];
      visibleControls.clear();
      document.documentElement.classList.remove(className);
      if (!mobile.matches) return;

      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visibleControls.add(entry.target);
          else visibleControls.delete(entry.target);
        });
        document.documentElement.classList.toggle(className, visibleControls.size > 0);
      }, { rootMargin: '24px 0px', threshold: 0 });
      syncControls();

      // Rebind if a size change replaces the buy-buttons markup.
      mutationObserver = new MutationObserver(syncControls);
      mutationObserver.observe(scope, { childList: true, subtree: true });
    };

    syncViewport();
    mobile.addEventListener('change', syncViewport);
  })();
  } catch(e) { console.error(e); }
})();

})();
